import { NgModule } from '@angular/core';
import { SplitByUppercasePipe } from './split-by-uppercase.pipe';

@NgModule({
  declarations: [
    SplitByUppercasePipe
  ],
  exports: [
    SplitByUppercasePipe
  ]
})
export class splitByUppercaseModule { }
